(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password-content"]) return;
  try {
    
	const pw = new URLSearchParams(window.location.search).get('kode')
	const pwField = document.getElementById('password')
	if (pw && pwField) {
		pwField.value = pw
	}

  } catch(e) { console.error(e); }
})();
})();
